module.exports = __webpack_public_path__ + "me_logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/me_logo.png
// module id = 402
// module chunks = 0